import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "album-bg"
};
var _hoisted_2 = {
  key: 0
};
var _hoisted_3 = {
  key: 0,
  class: "not-check"
};
var _hoisted_4 = {
  key: 1,
  class: "check-box"
};
var _hoisted_5 = {
  class: "num"
};
var _hoisted_6 = {
  class: "album"
};
var _hoisted_7 = {
  key: 1,
  class: "loading-indicator"
};
var _hoisted_8 = {
  key: 2,
  class: "no-more-data"
};
var _hoisted_9 = {
  key: 1,
  class: "empty"
};
import { MessagePlugin } from 'tdesign-vue-next';
import BaseEmpty from '../components/BaseEmpty.vue';
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { photos, setPhotoShowAndHide } from '@/api/personalHomepage';
import AlbumItem from '../components/albumItem.vue';
export default {
  __name: 'index',
  props: {
    clickRightValue: {
      type: Number,
      default: 0
    },
    clickLeftValue: {
      type: String,
      default: ''
    },
    IdPeople: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    // 分页参数
    var pageSize = ref(16);
    var currentPage = ref(1);
    var totalCount = ref(0);
    var photoData = ref([]);
    var loading = ref(false);
    var isFinish = ref(false);
    var isCheckModule = ref(false); // 隐藏、公开选择模式
    var spaceHideFlag = ref(); // 个人主页隐藏标记：0公开、1隐藏、默认为空：查询所有
    var checkList = ref([]); // 选择的列表
    // 相册接口数据
    var getPhotoData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(id) {
        var query, _photoData$value, _yield$photos, data, _data$data, records, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(loading.value || isFinish.value)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              loading.value = true;
              query = {
                size: pageSize.value,
                current: currentPage.value,
                userId: id,
                viewRadius: props.clickLeftValue,
                spaceHideFlag: props.clickRightValue === 1 ? null : 0
              };
              _context.p = 2;
              _context.n = 3;
              return photos(query);
            case 3:
              _yield$photos = _context.v;
              data = _yield$photos.data;
              _data$data = data.data, records = _data$data.records, total = _data$data.total;
              (_photoData$value = photoData.value).push.apply(_photoData$value, _toConsumableArray(records ? records : []));
              totalCount.value = total;
              isFinish.value = pageSize.value * currentPage.value >= total;
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              MessagePlugin.error('请求失败，请重试');
            case 5:
              _context.p = 5;
              loading.value = false;
              return _context.f(5);
            case 6:
              return _context.a(2);
          }
        }, _callee, null, [[2, 4, 5, 6]]);
      }));
      return function getPhotoData(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    // 刷新点赞
    var like = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              currentPage.value = 1;
              isFinish.value = false;
              photoData.value = [];
              _context2.n = 1;
              return getPhotoData(props.IdPeople);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function like() {
        return _ref2.apply(this, arguments);
      };
    }();
    watch(function () {
      return props;
    }, function (val) {
      var clickRightValue = val.clickRightValue;
      like();
      if (clickRightValue !== 1) {
        spaceHideFlag.value = null;
        isCheckModule.value = false;
      }
    }, {
      deep: true,
      immediate: true
    });
    var handleCheck = function handleCheck(val) {
      isCheckModule.value = true;
      spaceHideFlag.value = val;
    };
    var handleClose = function handleClose() {
      isCheckModule.value = false;
      checkList.value = [];
    };
    var handleComfrim = function handleComfrim() {
      if (checkList.value.length === 0) return MessagePlugin.error('请选择需要操作的内容');
      setPhotoShowAndHide({
        showOrHideOpt: spaceHideFlag.value,
        photoIds: checkList.value
      }).then(function (res) {
        handleClose();
        MessagePlugin.success('操作成功');
        like();
      });
    };
    var changeFlag = function changeFlag(val) {
      var index = checkList.value.findIndex(function (item) {
        return item === val;
      });
      if (index !== -1) return checkList.value.splice(index, 1);
      checkList.value.push(val);
    };
    var containerRef = ref(null);
    onMounted(function () {
      var container = containerRef.value;
      container.addEventListener('scroll', handleScroll);
    });
    onUnmounted(function () {
      var container = containerRef.value;
      container === null || container === void 0 || container.removeEventListener('scroll', handleScroll);
    });
    var handleScroll = function handleScroll() {
      var container = containerRef.value;
      if (!container) return;
      var scrollTop = container.scrollTop,
        scrollHeight = container.scrollHeight,
        clientHeight = container.clientHeight;
      if (scrollHeight - (scrollTop + clientHeight) < 100 && !loading.value && !isFinish.value) {
        currentPage.value++;
        getPhotoData(props.IdPeople, true);
      }
    };
    return function (_ctx, _cache) {
      var _component_t_button = _resolveComponent("t-button");
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([photoData.value.length > 0 ? 'album-container' : 'album-empty']),
        ref_key: "containerRef",
        ref: containerRef
      }, [photoData.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.clickRightValue === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [!isCheckModule.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return handleCheck(1);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode("隐藏内容", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return handleCheck(0);
        })
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("公开内容", -1)]));
        }),
        _: 1
      })])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", null, [_createTextVNode(" 已选择需要" + _toDisplayString(spaceHideFlag.value === 1 ? '隐藏' : '公开') + "的内容", 1), _createElementVNode("span", _hoisted_5, _toDisplayString(checkList.value.length), 1)]), _createElementVNode("div", null, [_createVNode(_component_t_button, {
        variant: "text",
        theme: "default",
        onClick: handleClose
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]));
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        variant: "text",
        theme: "primary",
        onClick: handleComfrim
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("确定", -1)]));
        }),
        _: 1
      })])]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(photoData.value, function (item) {
        return _openBlock(), _createBlock(AlbumItem, {
          key: item,
          data: item,
          "Id-people": __props.IdPeople,
          "click-left-value": __props.clickLeftValue,
          spaceHideFlag: spaceHideFlag.value,
          isCheckModule: isCheckModule.value,
          clickRightValue: __props.clickRightValue,
          onLike: like,
          onChangeFlag: changeFlag
        }, null, 8, ["data", "Id-people", "click-left-value", "spaceHideFlag", "isCheckModule", "clickRightValue"]);
      }), 128))]), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_t_loading, {
        size: "small"
      })])) : _createCommentVNode("", true), isFinish.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, "没有更多数据了")) : _createCommentVNode("", true)])) : _createCommentVNode("", true), photoData.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(BaseEmpty, {
        type: "2",
        "show-footer": __props.clickRightValue === 1 ? true : false
      }, null, 8, ["show-footer"])])) : _createCommentVNode("", true)], 2);
    };
  }
};